import { apiAuth, apiResponseType } from ".";

export const getWorkSchedulesData = (
  page: number = 1,
  unity_id?: string,
  name?: string
): apiResponseType =>
  apiAuth.get(
    `work-schedules?page=${page}${unity_id ? `&unity_id=${unity_id}` : ""}${
      name ? `&name=${encodeURIComponent(name)}` : ""
    }`
  );

export const registerWorkSchedulesData = (data) =>
  apiAuth.post("/work-schedules/store", data) as apiResponseType;

export const deleteWorkSchedulesData = (uuid: string) =>
  apiAuth.delete(`work-schedules/${uuid}/destroy`) as apiResponseType;

export const updateWorkSchedulesData = (uuid: string, data) =>
  apiAuth.post(`work-schedules/${uuid}/update`, data) as apiResponseType;

export const getShowWorkSchedules = (uuid: string) =>
  apiAuth.get(`work-schedules/${uuid}/show`) as apiResponseType;

export const searchWorkSchedulesData = (params: {
  name: string;
  unity_id?: string;
}): apiResponseType =>
  apiAuth.get(
    `work-schedules?name=${params.name}${
      params.unity_id ? `&unity_id=${params.unity_id}` : ""
    }`
  );

export const setStatusWorkSchedules = (uuid: string) =>
  apiAuth.put(`work-schedules/${uuid}/toggle-status`) as apiResponseType;

export const getSelectWorkSchedules = (unity_id?: number | string) =>
  apiAuth.get(
    `work-schedules/select${unity_id ? `?unity_id=${unity_id}` : ""}`
  ) as apiResponseType;
